import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("esp26_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const FIELD_TYPES = [
  { v: "short_text", l: "Short answer" },
  { v: "long_text", l: "Paragraph" },
  { v: "number", l: "Number" },
  { v: "date", l: "Date" },
  { v: "yes_no", l: "Yes / No" },
  { v: "single_choice", l: "Multiple choice" },
  { v: "multi_choice", l: "Checkboxes" },
  { v: "dropdown", l: "Dropdown" },
  { v: "rating", l: "Rating (1–5)" },
];
export const FIELD_TYPE_LABEL = Object.fromEntries(FIELD_TYPES.map((t) => [t.v, t.l]));
export const CHOICE_TYPES = ["single_choice", "multi_choice", "dropdown"];

export const ROLE_LABELS = {
  admin: "System Administrator",
  super_admin: "Super Administrator",
  rcsm: "Regional Clinical Service Manager",
  cnat: "Clinical Nurse Assessor / Trainer",
  hr: "HR",
  clinical_training_manager: "Clinical Training Manager",
  operations: "Operations",
  employee: "Employee",
};

export function titleCase(str = "") {
  return str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || titleCase(role);
}

export const HOURS_OPTIONS = ["Full Time", "Part Time", "Bank", "Zero Hours", "Fixed Term"];

export const TASK_TYPES = [
  { v: "general", l: "General" },
  { v: "supervision", l: "Supervision" },
  { v: "annual_assessment", l: "Annual Assessment (CNAT)" },
  { v: "annual_review", l: "Annual Review (RCSM)" },
  { v: "new_starter_initial_signoff", l: "New Starter Initial Sign Off" },
  { v: "six_eight_week_review", l: "6-8 Week Review" },
  { v: "monthly_1_1_review", l: "Monthly 1-1 Review" },
  { v: "field_visit", l: "Field Visit" },
  { v: "training", l: "Training" },
  { v: "support_visit", l: "Support Visit" },
];
export const TASK_TYPE_LABEL = Object.fromEntries(TASK_TYPES.map((t) => [t.v, t.l]));

export const WORK_STATUS = {
  requested: { label: "Requested", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  due: { label: "Due", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  scheduled: { label: "Scheduled", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const STATUS_META = {
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  probation: { label: "Probation", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  sickness: { label: "Sickness", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  offboarded: { label: "Off-boarded", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  other: { label: "Other", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();
}

const AVATAR_COLORS = [
  "bg-orange-100 text-orange-700",
  "bg-sky-100 text-sky-700",
  "bg-emerald-100 text-emerald-700",
  "bg-violet-100 text-violet-700",
  "bg-rose-100 text-rose-700",
  "bg-amber-100 text-amber-700",
];
export function avatarColor(name = "") {
  const sum = name.split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
}

export function ukDate(d = new Date()) {
  return new Date(d).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function shortDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
